var React = require('react');

function Quotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.866-31v15.44A44.946,44.946,0,0,1,36.333-1.206a61.75,61.75,0,0,1-7.117,14.434A52.114,52.114,0,0,1,18.44,25.13l-11.9-8.524A93.789,93.789,0,0,0,14.782,1.89a41.579,41.579,0,0,0,3.5-17.209V-31ZM79.8-31v15.44A44.946,44.946,0,0,1,77.264-1.206a61.75,61.75,0,0,1-7.117,14.434,52.114,52.114,0,0,1-10.776,11.9l-11.9-8.524A93.789,93.789,0,0,0,55.713,1.89a41.579,41.579,0,0,0,3.5-17.209V-31Z","transform":"translate(-6.539 31)","fill":"#fcf4e4"}));
}

Quotes.defaultProps = {"width":"73.258","height":"56.13","viewBox":"0 0 73.258 56.13"};

module.exports = Quotes;

Quotes.default = Quotes;
